/**
 * Cart complementary upsell — carousel + add-to-cart per card.
 */
(function () {
  class CartUpsell extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-upsell-track]');
      this.prevBtn = this.querySelector('[data-upsell-prev]');
      this.nextBtn = this.querySelector('[data-upsell-next]');

      this.onClick = this.onClick.bind(this);
      this.onChange = this.onChange.bind(this);
      this.onScroll = this.onScroll.bind(this);
      this.scrollBySlide = this.scrollBySlide.bind(this);

      this.addEventListener('click', this.onClick);
      this.addEventListener('change', this.onChange);
      if (this.track) this.track.addEventListener('scroll', this.onScroll, { passive: true });
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.scrollBySlide(-1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.scrollBySlide(1));

      this.updateNav();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('change', this.onChange);
      if (this.track) this.track.removeEventListener('scroll', this.onScroll);
    }

    onScroll() {
      this.updateNav();
    }

    updateNav() {
      if (!this.track || !this.prevBtn || !this.nextBtn) return;
      const maxScroll = this.track.scrollWidth - this.track.clientWidth - 2;
      this.prevBtn.disabled = this.track.scrollLeft <= 2;
      this.nextBtn.disabled = this.track.scrollLeft >= maxScroll;
    }

    scrollBySlide(direction) {
      if (!this.track) return;
      const slide = this.track.querySelector('[data-upsell-slide]');
      if (!slide) return;
      const amount = slide.getBoundingClientRect().width + 10;
      this.track.scrollBy({ left: direction * amount, behavior: 'smooth' });
    }

    onChange(event) {
      const select = event.target.closest('[data-upsell-variant]');
      if (!select || select.tagName !== 'SELECT') return;

      const card = select.closest('[data-upsell-card]');
      if (!card) return;

      const option = select.selectedOptions[0];
      const priceEl = card.querySelector('[data-upsell-price]');
      const addButton = card.querySelector('[data-upsell-add]');
      if (!option || !priceEl) return;

      const price = parseInt(option.dataset.price || '0', 10);
      const compare = parseInt(option.dataset.compare || '0', 10);
      const moneyFormat = window.theme?.settings?.money_format || '{{amount}}';

      if (compare > price) {
        priceEl.innerHTML =
          `<del>${formatMoney(compare, moneyFormat)}</del> <ins>${formatMoney(price, moneyFormat)}</ins>`;
      } else {
        priceEl.innerHTML = `<span>${formatMoney(price, moneyFormat)}</span>`;
      }

      if (addButton) addButton.disabled = option.disabled;
    }

    async onClick(event) {
      const addButton = event.target.closest('[data-upsell-add]');
      if (!addButton || addButton.disabled) return;

      event.preventDefault();
      const card = addButton.closest('[data-upsell-card]');
      if (!card) return;

      const variantInput = card.querySelector('[data-upsell-variant]');
      const spinner = card.querySelector('[data-upsell-spinner]');
      const label = card.querySelector('[data-upsell-add-label]');
      if (!variantInput) return;

      const id = variantInput.value;
      if (!id) return;

      addButton.disabled = true;
      if (spinner) spinner.classList.remove('hidden');
      if (label) label.classList.add('hidden');

      try {
        const cartDrawer = document.querySelector('cart-drawer');
        const sections = cartDrawer?.getSectionsToRender?.()?.map((s) => s.section) || ['cart-drawer', 'cart-counter'];

        const response = await fetch(window.routes.cart_add_url, {
          ...fetchConfig('javascript'),
          body: JSON.stringify({
            items: [{ id: Number(id), quantity: 1 }],
            sections,
            sections_url: window.location.pathname
          })
        });

        const data = await response.json();
        if (data.status && data.message) {
          throw new Error(data.description || data.message);
        }

        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(data, false);
          if (typeof updateFreeShipping === 'function') updateFreeShipping();
          if (typeof updateCartCounters === 'function') updateCartCounters();
        } else {
          window.location.href = window.routes.cart_url;
        }
      } catch (error) {
        console.error('Cart upsell add failed:', error);
        addButton.disabled = false;
      } finally {
        if (spinner) spinner.classList.add('hidden');
        if (label) label.classList.remove('hidden');
      }
    }
  }

  function formatMoney(cents, format) {
    if (typeof formatPrice === 'function') {
      return formatPrice(cents, format);
    }
    const amount = (Number(cents) / 100).toFixed(2);
    return format
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  }

  if (!customElements.get('cart-upsell')) {
    customElements.define('cart-upsell', CartUpsell);
  }
})();
